import { useEffect } from 'react';
import { useMap, useMapsLibrary } from '@vis.gl/react-google-maps';

function Polyline({ path, options }) {
  const map = useMap();
  const mapsLibrary = useMapsLibrary('maps');

  useEffect(() => {
    if (!map || !mapsLibrary || !path || path.length < 2) return;

    const polyline = new mapsLibrary.Polyline({
      path: path,
      ...options
    });

    polyline.setMap(map);

    return () => {
      polyline.setMap(null);
    };
  }, [map, mapsLibrary, path, options]);

  return null;
}

export default Polyline;